/**
 * Utility functions for CSV generation and download
 */

/**
 * Triggers a download of a CSV file
 * @param {string} content - The CSV content
 * @param {string} fileName - The name of the file to download
 */
export default function downloadCSV (content, fileName) {
  if (!fileName) {
    throw new Error('fileName is required')
  }

  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.setAttribute('download', fileName)
  link.setAttribute('href', blobUrl)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blobUrl)
}
